import API from '../api'
import postUrl from './paths'

export const createSupplierOrder = (supplierOrder) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createSupplierOrder, { ...supplierOrder })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const createSpoFromOrder = (orderId, supplierPoNumber) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createSpoFromOrder, {}, { orderId, supplierPoNumber })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})
